import script from "./BirthDetailsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./BirthDetailsModal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__